import React from "react";
import
{
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from "../../utility/helper";
import AppConstants from "../../constants/appConstants";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    cellContent: {
        width: '100px',
        flexBasis: '180px',
        // padding: 8
    }
}));

const RegistrationAccordianCard = (props) =>
{
    const classess = useStyles();
    const {item } = props;
    const RegistrationInfo = item.actualData;
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <CardContent className={classess.cardContent}>
                    {/* <Box className={classes.rowContent}> */}
                        <Box sx={{  
                                    display: 'grid',
                                    gridTemplateColumns:'repeat(7,1fr)',
                                    flexDirection: 'row',
                                    textAlign:'left',
                                    justifyContent:'left',
                                    alignItems:'left',
                                    gap:'10px',
                                    flexbasis:'900px'}}>
                    {RegistrationInfo.dob && <Box className={classess.cellContent}>
                        <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                     Date Of Birth
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.dob}</span>
                                </Typography>
                            </Box>
                            </Box>}
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                     Participant Contact No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.contactNo}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {RegistrationInfo.mailingAddress && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Participant Mailing Address
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.mailingAddress}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {(RegistrationInfo.reason == "" || RegistrationInfo.reason == null) && (Helper.getStorage('eventInfo').eventID !== props.eliteConfigEventID) && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                   Do you plan on participating in Five-on-Five Scrimmages?
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.isActivity1 ? 'YES' : 'NO'}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {(RegistrationInfo.reason == "" || RegistrationInfo.reason == null) && (Helper.getStorage('eventInfo').eventID !== props.eliteConfigEventID) && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                   Do you plan on participating in Live Action Offense vs Defense Drills?
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.isActivity2 ? 'YES' : 'NO'}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.attendingDraftNBA === true &&  (Helper.getStorage('eventInfo').eventID !== props.eliteConfigEventID) && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                   Are you interested in attending the NBA Draft? 
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.attendingDraftNBA ? 'YES' : 'NO'}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {props.showAgentProDayParticipant === true &&  (Helper.getStorage('eventInfo').eventID !== props.eliteConfigEventID) && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Planning to participate in agent Pro Day
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.agentProDayParticipant ? 'YES' : 'NO'}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {(RegistrationInfo.agentRoomRequestAccepted !== null && RegistrationInfo.agentRoomRequestAccepted !== "") && (Helper.getStorage('eventInfo').eventID !== props.eliteConfigEventID) ?<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    {AppConstants.HOTEL_AGENT_ROOM_CONFIRM_TEXT}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.agentRoomRequestAccepted ? 'YES' : 'NO'}</span>
                                </Typography>
                            </Box>
                        </Box> : null}
                        {/* {RegistrationInfo.agentProDayParticipant === true ?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    City
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.proCity}</span>
                                </Typography>
                            </Box>
                        </Box>):null} */}
                        {( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    I do not have a certified agent at this time
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isCertifiedAgentAttend ? "YES":"NO"}</span>
                                </Typography>
                            </Box>
                        </Box>)}
                        {RegistrationInfo.alternateContactName?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Certified Agent Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.alternateContactName}</span>
                                </Typography>
                            </Box>
                        </Box>):null}
                        {RegistrationInfo.alternateContactNo ?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Certified Agent Contact No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.alternateContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>):null}
                        {RegistrationInfo.alternateContactEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Certified Agent Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.alternateContactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.athleticDirectorName?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Director Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.athleticDirectorName}</span>
                                </Typography>
                            </Box>
                        </Box>):null} 
                        {RegistrationInfo.athleticDirectorEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Director Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.athleticDirectorEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.basketBallAdminName && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Basketball Admin Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.basketBallAdminName}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.basketBallAdminEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Basketball Admin Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.basketBallAdminEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.basketBallAdminContactNo && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Basketball Admin No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.basketBallAdminContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {/* {( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    I do not have a school/club athletic trainer at this time
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isFamilyMemberAttend ? "YES":"NO"}</span>
                                </Typography>
                            </Box>
                        </Box>)}                         */}
                        {RegistrationInfo.familyMemberContactName && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Family Member Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.familyMemberContactName}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.familyMemberContactEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Family Member Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.familyMemberContactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.familyMemberContactNo && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Family Member No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.familyMemberContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.personalPhysicianContactName && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Personal Physician Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.personalPhysicianContactName}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.personalPhysicianContactEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Personal Physician Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.personalPhysicianContactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.personalPhysicianContactNo && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Personal Physician No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.personalPhysicianContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.athleticTrainerName && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Athletic Trainer Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.athleticTrainerName}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.athleticTrainerCell && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Athletic Trainer Cell
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.athleticTrainerCell}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.athleticTrainerEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Athletic Trainer Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.athleticTrainerEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {/* {RegistrationInfo.dietRestrictions && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Diet Restrictions
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.dietRestrictions}</span>
                                </Typography>
                            </Box>
                        </Box>} */}
                        {/* {RegistrationInfo.eventForm !== null && RegistrationInfo.eventForm.FormFields.find(x => x.FieldValue === true && x.FieldName === 'NotAttend')&&RegistrationInfo.reason ?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Reason
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.reason}</span>
                                </Typography>
                            </Box>
                        </Box>):null} */}
                        {RegistrationInfo.guestList && RegistrationInfo.guestList !== null && RegistrationInfo.guestList?.length > 0 && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Guests
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.guestList.map((x) => `${x.name}`).join(', ')}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.lunchGuestList && RegistrationInfo.lunchGuestList !== null && RegistrationInfo.lunchGuestList?.length > 0 && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Lunch Guests
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.lunchGuestList.map((x) => `${x.name}`).join(', ')}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.eventForm !== null && RegistrationInfo.eventForm.FormFields.find(x => x.FieldValue === true && x.FieldName === 'NotAttend')&&RegistrationInfo.reason ?( <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Reason
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.reason}</span>
                                </Typography>
                            </Box>
                        </Box>):null}
                        {RegistrationInfo.lastModifiedDate!=="0001-01-01T00:00:00" 
                       && RegistrationInfo.lastModifiedDate !== null ?
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{Helper.FormatDateTime(RegistrationInfo.lastModifiedDate)}</span>
                                    </Typography>
                                </Box>
                            </Box>
                            : ""}
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default RegistrationAccordianCard;